/**
 * @copyright 2026 @ DigiNet
 * @author ANHTAI
 * @create 2026/07/13 09:15
 * @update 2026/07/13 09:15
 */

import { Column } from "devextreme-react/data-grid";
import { ButtonIcon, Col, DatePicker, Dropdown, Label, NumberInput, Row, Typography } from 'diginet-core-ui/components';
import { makeStyles } from "diginet-core-ui/theme";
import React, { useEffect, useMemo, useState } from 'react';
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import { bindActionCreators } from "redux";
import exportFlexReport from "../../../actions/export-flex-report";
import * as userActions from "../../../actions/user-actions";
import * as W07F2010Actions from "../../../actions/w07/w07F2010/w07F2010-actions";
import * as W07F2020Actions from "../../../actions/w07/w07F2020/w07F2020-actions";
import Config from "../../../config";
import GridActionBar from "../../common/action-bar/grid-action-bar-hover";
import GridContainer from "../../common/grid-container/grid-container";
import ActionToolbar from "../../common/tool-bar/action-toolbar";
import ModalHistory from "./W07F2010ModalHistory";

const useStyles = makeStyles({
    moneyInputColumn: {
        width: '100%',
        margin: 0,
        '& input': {
            textAlign: 'right'
        }
    },
    ddColumn: {
        marginBottom: 0,
    }
});

const FormID = 'W07F2010';

const W07F2010 = (props) => {
    const classes = useStyles();
    const [iPermission, setIPermission] = useState(null);
    const [formLoading, setFormLoading] = useState(false);
    const [cboPeriodLoading, setCboPeriodLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [search, setSearch] = useState('');
    const [dataExport, setDataExport] = useState({
        downloadURLExport: '',
        downloadNameExport: '',
    });
    const [dataFilter, setDataFilter] = useState({
        DateFrom: null,
        DateTo: null,
        PeriodFrom: null,
        PeriodTo: null,
    });
    const [dataGrid, setDataGrid] = useState([]);
    const [dataCboPeriodFrom, setDataCboPeriodFrom] = useState([]);
    const [dataCboPeriodTo, setDataCboPeriodTo] = useState([]);
    const [dataColumnGrid, setDataColumnGrid] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);

    useEffect(() => {
        loadPermission();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!iPermission) return;
        loadDynamicColumn();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission]);

    useEffect(() => {
        if (!iPermission) return;
        loadGrid();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission, search, dataFilter]);

    const loadPermission = () => {
        props.userActions.getPermission(Config.profile.UserID, FormID, (iPer) => {
            setIPermission(iPer)
        });
    };

    const exportExcel = async () => {
        const params = getParamGeneral('export');
        setFormLoading(true);
        await exportFlexReport('/w07f2010/export', params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataExport({
                    downloadURLExport: data.URL || "",
                    downloadNameExport: data.fileName || "",
                });
                setTimeout(() => {
                    const el = document.getElementById("exportReportUrlLink");
                    el.click();
                }, 300);
            }
        });
    };

    const renderColByType = (data) => {
        const { Width = 150, IsPermanent, Caption = '', FieldName = '', DataType = '', } = data || {};
        let colProps = {};
        if (DataType.includes('DECIMAL')) {
            colProps = {
                dataType: 'number',
                alignment: 'right',
                cellRender: (e) => <NumberInput
                    readOnly
                    nonStyle
                    disabledNegative
                    decimalDigit={4}
                    thousandSeparator={','}
                    value={e?.value}
                    className={classes.moneyInputColumn}
                />
            };

        } else if (DataType.includes('DATETIME')) {
            colProps = {
                alignment: 'center',
                dataType: 'date',
                format: 'dd/MM/yyyy HH:mm:ss'
            };

        } else if (DataType.includes('INT')) {
            colProps = {
                alignment: 'right',
                dataType: 'number',
            };
        }
        if (IsPermanent === 1) colProps = { ...colProps, fixed: true, fixedPosition: 'left' };
        if (FieldName.includes('Status')) colProps = { cellRender: (e) => <Typography color={e?.data?.StatusColor}>{e?.value}</Typography> };
        return <Column
            key={FieldName}
            width={Width}
            caption={Caption}
            dataField={FieldName}
            {...colProps}
        />
    };

    const loadDynamicColumn = () => {
        const params = getParamGeneral();
        props.W07F2010Actions.loadDynamicColumn(params, (error, data) => {
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                const dataCol = data.map(item => renderColByType(item));
                setDataColumnGrid(dataCol);
            }
        });
    };

    const loadGrid = () => {
        const params = getParamGeneral('loadGrid');
        setFormLoading(true);
        props.W07F2010Actions.loadGrid(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataGrid(data || []);
            }
        });
    };

    const onOpenLoaded = () => {
        loadCboPeriod();
    };

    const getParamGeneral = (type, data) => {
        const { RDVoucherID = '' } = data || {};
        let params = {
            DateFrom: null,
            DateTo: null,
            PeriodFrom: null,
            PeriodTo: null,
            RDVoucherID: '',
            StrSearch: search,
        };
        switch (type) {
            case 'loadGrid':
            case 'export':
                params = { ...params, ...dataFilter };
                break;
            case 'deleteRow':
            case 'checkEdit':
                params.RDVoucherID = RDVoucherID;
                break;
            default:
                break;
        }
        if (!Config.isEmpty(params?.PeriodFrom) && Config.typeOf(params?.PeriodFrom, 'string')) params.PeriodFrom = Number(params.PeriodFrom.replace(/\s/g, ""));
        if (!Config.isEmpty(params?.PeriodTo) && Config.typeOf(params?.PeriodTo, 'string')) params.PeriodTo = Number(params.PeriodTo.replace(/\s/g, ""));
        return params;
    };

    const loadCboPeriod = () => {
        const params = getParamGeneral();
        setCboPeriodLoading(true);
        props.W07F2010Actions.loadComboPeriod(params, (error, data) => {
            setCboPeriodLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataCboPeriodFrom(data?.[0] || []);
                setDataCboPeriodTo(data?.[1] || []);
            }
        });
    };

    const checkEdit = (dataRow) => {
        const params = getParamGeneral('checkEdit', dataRow);
        setFormLoading(true);
        props.W07F2020Actions.checkEdit(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (data?.Status === 0) handleRedirect('edit', dataRow);
                else if (data?.Status === 1 && data?.Message) Config.popupCore.show('WARNING', data.Message);
            }
        });
    };

    const onCloseModal = () => {
        setOpenModal(false);
    }

    const checkHistory = (dataRow) => {
        setSelectedRow(dataRow);
        setOpenModal(true);
    };

    const handleRedirect = (mode, dataRow = {}) => {
        browserHistory.push({
            pathname: Config.getRootPath() + 'W07F2020',
            state: {
                mode,
                ...dataRow
            }
        });
    };

    const deleteRow = (e) => {
        Config.popupCore.show('YES_NO', `${Config.lang('Ban_co_chac_chan_muon_xoa_du_lieu_nay')}`, () => {
            const params = getParamGeneral('deleteRow', e?.data);
            props.W07F2010Actions.onDeleteRow(params, (error, data) => {
                if (error) {
                    Config.popupCore.show('ERROR', error);
                    return false;
                } else if (data) {
                    if (data?.Status === 0) {
                        Config.notify.show('success', Config.lang('Du_lieu_da_xoa_thanh_cong'), 2000);
                        loadGrid();
                    } else if (data?.Message) {
                        Config.popupCore.show('WARNING', data.Message);
                    }
                }
            })
        })
    };

    const renderButtonAction = (e) => {
        if (!e) return null;
        return (
            <GridActionBar>
                <div className={"display_row align-center"}>
                    <ButtonIcon
                        circular
                        viewType={"text"}
                        name={"History"}
                        title={Config.lang('Lich_su')}
                        disabled={e?.data?.IsHistory !== 1}
                        onClick={() => checkHistory(e?.data)}
                    />
                    <ButtonIcon
                        circular
                        viewType={"text"}
                        name={"Edit"}
                        title={Config.lang('Sua')}
                        disabled={iPermission <= 2}
                        onClick={() => checkEdit(e?.data)}
                    />
                    <ButtonIcon
                        circular
                        viewType={"text"}
                        name={"Delete"}
                        title={Config.lang('Xoa')}
                        disabled={iPermission <= 3}
                        onClick={() => deleteRow(e)}
                    />
                </div>
            </GridActionBar>
        )
    };

    const btnCRM = [
        {
            buttonName: Config.lang("Xuat_du_lieu"),
            buttonType: 'button',
            icon: 'Sheet',
            color: 'Success',
            align: 'right',
            disabled: false,
            onClick: () => exportExcel()
        }];

    const onSearch = (text = '') => {
        setSearch(text);
    };

    const onChangeFilter = (keyName, e) => {
        if (!e || !keyName) return;
        let value = e?.value ?? e?.target?.value ?? '';
        if (Config.isEmpty(value) && ['DateFrom', 'DateTo'].includes(keyName)) value = null;
        const objPlus = { ...dataFilter, [keyName]: value };
        setDataFilter(objPlus);
    };

    const filterRender = () => {
        return <Row>
            <Col xs={12} sm={12} md={6} lg={6}>
                <Row>
                    <Col xs={12} sm={6}>
                        <div className={"display_row align-center"}>
                            <Label className={'mgr4x'} style={{ whiteSpace: 'nowrap' }}>{Config.lang('Ngay_phieu')}</Label>
                            <DatePicker
                                clearAble
                                viewType={'outlined'}
                                displayFormat={"DD/MM/YYYY"}
                                placeholder={Config.lang('Tu')}
                                max={dataFilter?.DateTo}
                                value={dataFilter?.DateFrom}
                                className={'full_w'}
                                onChange={e => onChangeFilter('DateFrom', e)}
                            />
                            <div className={'pdl4x'}>-</div>
                        </div>
                    </Col>
                    <Col xs={12} sm={6}>
                        <DatePicker
                            clearAble
                            viewType={'outlined'}
                            displayFormat={"DD/MM/YYYY"}
                            placeholder={Config.lang('Den')}
                            min={dataFilter?.DateFrom}
                            value={dataFilter?.DateTo}
                            onChange={e => onChangeFilter('DateTo', e)}
                        />
                    </Col>
                </Row>
            </Col>
            <Col xs={12} sm={12} md={6} lg={6}>
                <Row>
                    <Col xs={12} sm={6}>
                        <div className={"display_row align-center"}>
                            <Label className={'mgr4x'} style={{ whiteSpace: 'nowrap' }}>{Config.lang('Ky')}</Label>
                            <Dropdown
                                required
                                viewType={'outlined'}
                                valueExpr={'PeriodFrom'}
                                displayExpr={'PeriodFrom'}
                                loading={cboPeriodLoading}
                                dataSource={dataCboPeriodFrom}
                                placeholder={Config.lang('Tu')}
                                value={dataFilter?.PeriodFrom}
                                className={'full_w'}
                                onChange={e => onChangeFilter('PeriodFrom', e)}
                            />
                            <div className={'pdl4x'}>-</div>
                        </div>
                    </Col>
                    <Col xs={12} sm={6}>
                        <Dropdown
                            required
                            viewType={'outlined'}
                            valueExpr={'PeriodTo'}
                            displayExpr={'PeriodTo'}
                            loading={cboPeriodLoading}
                            dataSource={dataCboPeriodTo}
                            placeholder={Config.lang('Den')}
                            value={dataFilter?.PeriodTo}
                            onChange={e => onChangeFilter('PeriodTo', e)}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    };

    const renderGrid = useMemo(() => {
        return (
            <GridContainer
                isShowFilter
                dataSource={dataGrid}
                onAddNew={() => handleRedirect('add')}
                onDbCellClick={(e) => handleRedirect('view', e?.data)}
                isPer={iPermission}
                buttonCRM={btnCRM}
                loading={formLoading}
                typePaging={'normal'}
                keyExpr={'RDVoucherID'}
                pagerFullScreen
                itemPerPage={20}
                listPerPage={[20, 40, 60, 80]}
                valueSearch={search}
                onSearch={onSearch}
                filterRender={filterRender()}
                onOpenLoaded={onOpenLoaded}  >
                <Column
                    caption={Config.lang("Hanh_dong")}
                    visible={Config.isMobile}
                    alignment={"center"}
                    allowEditing={false}
                    cellRender={e => renderButtonAction(e)}
                />
                {dataColumnGrid}
                <Column
                    fixed
                    minWidth={90}
                    fixedPosition={"right"}
                    visible={!Config.isMobile}
                    cellRender={e => renderButtonAction(e)}
                />
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission, dataGrid, formLoading, dataCboPeriodFrom, dataCboPeriodTo, cboPeriodLoading, dataColumnGrid]);

    if (!iPermission) return null;
    return (
        <>
            {openModal &&
                <ModalHistory
                    open={openModal}
                    onClose={onCloseModal}
                    dataRow={selectedRow}
                />
            }
            <div className={'page-container'} style={{ height: '100vh' }}>
                <ActionToolbar title={Config.lang("Danh_sach_phieu_dieu_chuyen_noi_bo")} />
                <Row><Col xs={12}>{renderGrid}</Col></Row>
                <a id={"exportReportUrlLink"} className={"hide"} download={dataExport.downloadNameExport}
                    href={dataExport.downloadURLExport}>File</a>
            </div>
        </>
    );
}

export default connect(null, (dispatch) => ({
    W07F2010Actions: bindActionCreators(W07F2010Actions, dispatch),
    W07F2020Actions: bindActionCreators(W07F2020Actions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
}))(W07F2010);


